<template>
	<div v-if="!mobile" class="title_box mb_20">
		<h3 class="modal_title_m mb_16">
			{{ $t('merchant.settlement.title1') }}
		</h3>
	</div>
	<CustomSelectBox
		ref="sourceSelect"
		:placeholder="$t('merchant.settlement.select')"
		:options="ownAssets"
		@selectItem="selectAsset"
		class="mb_40"
	></CustomSelectBox>
	<!-- 웹일때 버튼 -->
	<div v-if="!mobile" :class="[{ button_area_type01: mobile }, 'button_area']">
		<button @click="$emit('closeModal')">
			{{ $t('button.cancel') }}
		</button>
		<button :disabled="!canConnect" class="fc_red" @click="onRegist">
			{{ $t('button.connect') }}
		</button>
	</div>
	<!-- 모바일 일때 버튼 -->
	<div v-if="mobile" class="mobile_button_area">
		<button
			:disabled="!canConnect"
			class="button_round button_bg_red"
			@click="onRegist"
		>
			{{ $t('button.connect') }}
		</button>
	</div>
</template>

<script>
import CustomSelectBox from '@/components/CustomSelectBox';
import { isMobile } from '@/common/mobile';
import { mapGetters } from 'vuex';
import { createMerchantAccount } from '@/api/pg';
import { commonError } from '@/common/dialog';

export default {
	name: 'SettlementAccountRegister',
	props: {
		selectedMerchantInfo: {
			type: Object,
		},
	},
	emits: ['successRegist', 'closeModal'],
	components: { CustomSelectBox },
	data() {
		return {
			assetSeq: '',
			mobile: isMobile(),
		};
	},
	computed: {
		...mapGetters('assets', ['assets']),
		...mapGetters('account', ['accounts']),
		...mapGetters('account', ['own_assets_group']),
		ownAssets() {
			let data = [];
			const group = Object.keys(this.own_assets_group).map(Number);
			this.assets.forEach(assetItem => {
				if (group.includes(assetItem.seq)) data.push(assetItem);
			});
			return data;
		},
		selectedAccountInfo() {
			return this.accounts.find(item => {
				return item.asset_seq === this.assetSeq;
			});
		},
		canConnect() {
			return !!this.selectedAccountInfo;
		},
		currentRoute() {
			return this.$route.name;
		},
	},
	methods: {
		async onRegist() {
			if (this.currentRoute !== 'merchant-management') {
				const params = {
					merchant_seq: this.$route.params.merchant_seq,
					account_seq: this.selectedAccountInfo.seq,
				};
				await createMerchantAccount(params)
					.then(() => {
						this.$emit('successRegist');
					})
					.catch(commonError);
			} else {
				const params = {
					merchant_seq: this.selectedMerchantInfo.seq,
					account_seq: this.selectedAccountInfo.seq,
				};
				await createMerchantAccount(params)
					.then(() => {
						this.$emit('successRegist');
					})
					.catch(commonError);
			}
		},
		selectAsset(assetSeq) {
			this.assetSeq = assetSeq;
		},
	},
};
</script>
